module.exports = __webpack_public_path__ + "src/assets/img/menu_icon_7_green.915b0b98.svg";